module.exports = __webpack_public_path__ + "01_mid_brown.4bf99938.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/papa/layer5/01_mid_brown.png
// module id = vhon
// module chunks = 0